import type { ComponentType, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './relacionatsmarato.module.scss';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
import Icona from '../../Icona/Icona';
import __isEmpty from 'lodash/isEmpty';
import { RelacionatsMaratoProps } from './RelacionatsMarato.types';

const EnllacLink = Enllac as ComponentType<{
    title?: string;
    className?: string;
    type?: string;
    route?: { slug?: string; id?: string; slug2?: string };
    children: ReactNode;
}>;

export default function RelacionatsMarato(props: Readonly<RelacionatsMaratoProps>) {
    const { edicio = '0', seccio = '', relacionat = '', type } = props;
    const mostraAudios = edicio === '0' || edicio > '2013';
    const mostraNoticies = edicio === '0' || edicio >= '2005';

    const stylesLlistat = clsx({
        [styles.llistatContinguts]: true
    });

    return (
        <section className={styles.llistatContinguts}>
            <ul>
                <li>
                    <EnllacLink
                        title='Vídeos'
                        className={`${stylesLlistat} ${relacionat === 'videos' ? styles.seccioActiva : ''}`}
                        type={type}
                        route={{ slug: 'videos', slug2: edicio, id: seccio }}
                    >
                        <Icona icona='play' path='noticies' className={styles.iconaLlistat} inline={true} />
                        <span>Vídeos</span>
                    </EnllacLink>
                </li>

                {mostraAudios && (
                    <li>
                        <EnllacLink
                            title='Àudios'
                            className={`${stylesLlistat} ${relacionat === 'audios' ? styles.seccioActiva : ''}`}
                            type={type}
                            route={{ slug: 'audios', slug2: edicio, id: seccio }}
                        >
                            <Icona icona='auriculars' path='noticies' className={styles.iconaLlistat} inline={true} />
                            <span>Àudios</span>
                        </EnllacLink>
                    </li>
                )}

                {mostraNoticies && (
                    <li>
                        <EnllacLink
                            title='Notícies'
                            className={`${stylesLlistat} ${relacionat === 'noticies' ? styles.seccioActiva : ''}`}
                            type={type}
                            route={{ slug: 'noticies', slug2: edicio, id: seccio }}
                        >
                            <Icona icona='llista' path='noticies' className={styles.iconaLlistat} inline={true} />
                            <span>Notícies</span>
                        </EnllacLink>
                    </li>
                )}
            </ul>
        </section>
    );
}
